<template>
    <ConfirmationModal
        :visible.sync="showModal"
        :is-loading="isLoading"
        :is-submiting="isSubmiting"
        :disabled="!selectedId"
        title="Logar como distribuidor"
        description="Deseja realmente logar como distribuidor?"
        confirm-text="Confirmar"
        cancel-text="Cancelar"
        icon="el-icon-check"
        confirm-type="success"
        tag-type="success"
        @cancel="toggleModal"
        @confirm="onSubmit"
        @closed="resetModal"
    >
        <div v-if="payload" class="d-flex align-items-center">
            <i class="el-icon-right"></i>
            <span class="font-weight-bold ml-2">{{ payload.nome }}</span>
        </div>
    </ConfirmationModal>
</template>
<script>
    // Components
    import { Notification } from "element-ui";

    import ConfirmationModal from "@/components/_micro/modals/ConfirmationModal.vue";

    // Api
    import { DistribuidorApi } from "@/api/DistribuidorApi";

    const distribuidorApi = new DistribuidorApi();

    export default {
        data() {
            return {
                selectedId: null,
                payload: null,
                showModal: false,
                isLoading: false,
                isSubmiting: false,
            }
        },
        methods: {
            async show() {
                this.isLoading = true
                
                try {
                    const res = await distribuidorApi.show(this.selectedId);

                    this.payload = res
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o distribuidor. Algo inesperado ocorreu!'
                    })
                } finally {
                    this.isLoading = false
                }
            },
            async onSubmit() {
                if (!this.selectedId) return;

                this.isSubmiting = true;

                try {
                    window.location.assign(`/adm/logarComo/${this.payload.user_id}`);
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível logar como distribuidor!'
                    });
                    console.log(error);
                } finally {
                    this.isSubmiting = false;
                    this.toggleModal();
                }
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetModal() {
                this.selectedId = null;
                this.notificacao = null;
            },
        },
        components: {
            ConfirmationModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_internal/distribuidor/DistribuidorLoginAs.vue